import React, { useState, useEffect } from 'react';
import { api } from '../utils/apiClient';
import { useNavigate } from 'react-router-dom';
import './custom.css';

function SignUpModal({ onSignUpSuccess }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errorMessages, setErrorMessages] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const updateFormData = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrorMessages({ ...errorMessages, [field]: '' });
  };

  const validateForm = () => {
    let newErrors = {};
    const nameRegex = /^[A-Za-z0-9_-]{1,30}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$&*]).{8,12}$/;

    if (!nameRegex.test(formData.firstName)) {
      newErrors.firstName = 'First Name must be 1-30 characters long with no special characters.';
    }
    if (!nameRegex.test(formData.lastName)) {
      newErrors.lastName = 'Last Name must be 1-30 characters long with no special characters.';
    }
    if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Enter a valid email address.';
    }
    if (!passwordRegex.test(formData.password)) {
      newErrors.password = 'Password must be 8-12 characters with at least one uppercase, one lowercase, one number, and one special character (!@#$&*).';
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match.';
    }

    setErrorMessages(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    try {
      await api.post('/signup', {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
      });

      setSuccessMessage('User created successfully.');

      // No immediate redirection here

    } catch (error) {
      setErrorMessages({ form: 'Failed to sign up. Please try again.' });
      console.error('Sign up error:', error.response || error);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
        navigate('/login');
      }, 5000); // Delayed redirection after success message display

      return () => clearTimeout(timer);
    }
  }, [successMessage, navigate]);

  const handleSignInClick = () => {
    navigate('/login');
  };

  const handleClose = () => {
    navigate('/login');
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="signup-modal">
          {successMessage && <div className="success-message">{successMessage}</div>}
          <form onSubmit={handleSubmit}>
            <h2>Sign Up</h2>
            <div className="form-group">
            <label htmlFor="firstName">First Name <span className="required-asterisk">*</span></label>
            <input
              id="firstName"
              type="text"
              placeholder="John"
              value={formData.firstName}
              onChange={(e) => updateFormData('firstName', e.target.value)}
            />
            {errorMessages.firstName && <div className="error-message">{errorMessages.firstName}</div>}
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Last Name <span className="required-asterisk">*</span></label>
            <input
              id="lastName"
              type="text"
              placeholder="Doe"
              value={formData.lastName}
              onChange={(e) => updateFormData('lastName', e.target.value)}
            />
            {errorMessages.lastName && <div className="error-message">{errorMessages.lastName}</div>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address <span className="required-asterisk">*</span></label>
            <input
              id="email"
              type="email"
              placeholder="john.doe@example.com"
              value={formData.email}
              onChange={(e) => updateFormData('email', e.target.value)}
            />
            {errorMessages.email && <div className="error-message">{errorMessages.email}</div>}
          </div>
          <div className="form-group">
            <label htmlFor="password">Password <span className="required-asterisk">*</span></label>
            <input
              id="password"
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={(e) => updateFormData('password', e.target.value)}
            />
            {errorMessages.password && <div className="error-message">{errorMessages.password}</div>}
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password <span className="required-asterisk">*</span></label>
            <input
              id="confirmPassword"
              type="password"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={(e) => updateFormData('confirmPassword', e.target.value)}
            />
            {errorMessages.confirmPassword && <div className="error-message">{errorMessages.confirmPassword}</div>}
          </div>
          <div className="form-group checkbox-group">
            <input type="checkbox" id="privacyPolicy" />
            <label htmlFor="privacyPolicy" className="privacy-policy-text">
              By selecting Submit, I agree to Truvex’s Privacy Policy.
            </label>
            </div>
            <div className="button-group">
              <button type="button" className="cancel-button" onClick={handleClose}>Cancel</button>
              <button type="submit" className="submit-button">Submit</button>
            </div>
            <div className="login-link">
              <span onClick={handleSignInClick}>Already have an account? Sign In</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignUpModal;
